import {EventEmitter, Injectable}   from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class ClienteIndicacaoService {

    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Cliente indicacoes por id
     * @param id ID da Cliente indicacoes
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "indicacoes-clientes/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Cliente indicacoes
     * @param id ID da Cliente indicacoes
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "indicacoes-clientes"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Cliente indicacoes
     * @param id ID da Cliente indicacoes
     */
    search(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "indicacoes-clientes"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Cliente indicacoes
     * @param id ID da Cliente indicacoes
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "indicacoes-clientes/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Cliente indicacoes
     * @param params Json Cliente indicacoes
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "indicacoes-clientes", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Cliente indicacoes
     * @param params Json Cliente indicacoes
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "indicacoes-clientes/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}
